export default "__VITE_PUBLIC_ASSET__d9cd06b9__"